interface BackButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  testId?: string;
}

export function BackButton({ onClick, ariaLabel = "Back", testId = "header_btn-back" }: BackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      data-testid={testId}
      className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2D55FB] focus-visible:ring-offset-2 transition-colors"
    >
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <rect
          width="35"
          height="35"
          rx="17.5"
          transform="matrix(-1 0 0 1 35 0)"
          fill="#e0e0e0"
        />
        <path
          d="M23.0935 17.5H11.8982"
          stroke="black"
          strokeWidth="0.717394"
          strokeLinejoin="round"
        />
        <path
          d="M16.4509 12.9529L11.9029 17.5009L16.4509 22.049"
          stroke="black"
          strokeWidth="0.717394"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
